import api from 'api'

export type DayforceAgency = {
  id: string
  name: string
  dayforceBaseUrl: string
}

export type ListDayforceAgenciesResponse = {
  items: DayforceAgency[]
}

export const listDayforceAgencies =
  async (): Promise<ListDayforceAgenciesResponse> => {
    const response = await api.get<ListDayforceAgenciesResponse>(
      '/admin/dayforce/agencies'
    )
    return response.data
  }
